<template>
    <v-card raised class="mb-4">
        <v-layout row wrap>
        <v-flex xs12 md6>
            <v-layout v-if="!isHide('Agreement')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex d-flex xs4>{{$t("Agreement")}}:</v-flex>
              <v-flex d-flex xs8 style="padding-right: 6px">{{recentReg.AgreementNo}} - {{recentReg.AgreementName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Customer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex d-flex xs4>{{$t("Customer")}}:</v-flex>
              <v-flex d-flex xs8 style="padding-right: 6px">{{getCustomerStr(recentReg)}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Plant')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex d-flex xs4>{{$t("Plant")}}:</v-flex>
              <v-flex d-flex xs8 style="padding-right: 6px">{{recentReg.PlantNo}} - {{recentReg.PlantName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Article')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex d-flex xs4>{{$t("Article")}}:</v-flex>
              <v-flex d-flex xs8 style="padding-right: 6px">{{recentReg.ArticleNo}} - {{recentReg.ArticleName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Carrier')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex d-flex xs4>{{$t("Carrier")}}:</v-flex>
              <v-flex d-flex xs8 style="padding-right: 6px">{{recentReg.CarrierNo}} - {{recentReg.CarrierName}}</v-flex>
            </v-layout>
        </v-flex>
        <v-flex xs12 md6>
            <v-layout v-if="!isHide('Batches registered')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex class="font-weight-bold" d-flex xs4>{{$t("Batches registered")}}:</v-flex>
              <v-flex class="font-weight-bold" d-flex xs8>{{recentReg.RegistrationCount}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('RequisitionNo1')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex d-flex xs4>{{$t("RequisitionNo1")}}:</v-flex>
              <v-flex d-flex xs8>{{recentReg.RequisitionNo}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Weight')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex d-flex xs4>{{$t("Weight")}}:</v-flex>
              <v-flex d-flex xs8>{{recentReg.WeightNet}} kg.</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('RegistrationNo')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
              <v-flex d-flex xs4>{{$t("ScanXRegNo")}}:</v-flex>
              <v-flex d-flex xs8>{{recentReg.ScanXRegNo}}</v-flex>
            </v-layout>
        </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
import * as Security from '@/core/security'
import * as BatchRegistration from '@/modules/batch-registration/batch-registration'

export default {
  props: ['recentReg'],
  data () {
    return {
      hiddenFields: [],
      cancelTimer: null
    }
  },
  methods: {
    getCustomerStr (recentReg) {
      if (recentReg.CustomerNo && recentReg.CustomerName) { return recentReg.CustomerNo + ' - ' + recentReg.CustomerName } else if (recentReg.CustomerNo) { return recentReg.CustomerNo } else if (recentReg.CustomerName) { return recentReg.CustomerName } else { return '' }
    },
    getWeightStr (recentReg) {
      return Math.abs(recentReg.WeightNet) + ' kg'
    },
    isHide (fieldName) {
      return this.hiddenFields.some(h => h === fieldName)
    },
    async printRegistration (recentReg) {
      this.loading = true
      const res = BatchRegistration.RePrintRegistration(recentReg)
      if (!res.failed) {
        this.registrations = res.data
      }

      this.loading = false
    }
  },
  beforeDestroy () {
    // Stop Cancel timer
    if (this.cancelTimer) clearInterval(this.cancelTimer)
  },
  async mounted () {
    // Use Settings from cached user's corporatationDetails
    if (Security.user.corporationDetails) {
      // const defaultHidden = 'RequisitionNo2,Plant,Carrier,Comment' // New fields default hidden LSV/MITH. Remember to also add new defaults in Settings.vue and Registration.vue
      const defaultHidden = 'RequisitionNo2,Comment' // New fields default hidden LSV/MITH. Remember to also add new defaults in Settings.vue and Registration.vue
      this.hiddenFields = (Security.user.corporationDetails.find(d => d.Name === 'recentRegistration_Fields_Hidden')?.Data1 ?? defaultHidden).split(',')
    }
  }

}
</script>
